import React, { useEffect, useState } from 'react';
import './NotificationModal.css';

const NotificationModal = ({ notification, onClose }) => {
  const [isClosing, setIsClosing] = useState(false);

  useEffect(() => {
    if (notification.show && notification.autoHide !== false) {
      const timer = setTimeout(() => {
        setIsClosing(true);
        setTimeout(() => {
          onClose();
          setIsClosing(false);
        }, 300); // Wait for slide-out animation to complete
      }, notification.duration || 2000);
      
      return () => clearTimeout(timer);
    }
  }, [notification.show, notification.autoHide, notification.duration, onClose]);

  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === 'Escape' && notification.show) {
        setIsClosing(true);
        setTimeout(() => {
          onClose();
          setIsClosing(false);
        }, 300);
      }
    };
    
    if (notification.show) {
      window.addEventListener('keydown', handleEsc);
      return () => window.removeEventListener('keydown', handleEsc);
    }
  }, [notification.show, onClose]);

  if (!notification.show) return null;

  return (
    <div className={`notification-modal ${isClosing ? 'slide-out' : ''}`}>
      <div className={`notification-content ${notification.type}`}>
        <div className="notification-icon">
          {notification.type === 'success' && '✓'}
          {notification.type === 'error' && '✕'}
          {notification.type === 'warning' && '⚠'}
          {notification.type === 'info' && 'ℹ'}
        </div>
        <div className="notification-message">
          {notification.message}
        </div>
        {notification.autoHide !== false && (
          <button className="notification-close" onClick={() => {
            setIsClosing(true);
            setTimeout(() => {
              onClose();
              setIsClosing(false);
            }, 300);
          }}>
            ×
          </button>
        )}
      </div>
    </div>
  );
};

export default NotificationModal; 